import PrivacyPolicy from "../../modules/privacy-policy/PrivacyPolicy.vue";

const PrivacyRoutes =     
    { path: '/privacy-policy', component: PrivacyPolicy }
  


export default PrivacyRoutes;